module.exports = __webpack_public_path__ + "img/gis1_on.aedd4fb3.png";